import * as React from "react"
import { useContext, useState } from "react"
import { Context } from "../../store/store"
import Slider from "react-slick"
import "../../slickslider.css"
import RefundCounter from "../RecoundCounter"
import { Link } from "react-router-dom"

interface SoGehtsProps {
	type?: any
}

const Sogehts: React.FC<SoGehtsProps> = ({ type = "" }) => {
	const { dispatch } = useContext(Context)
	const [arrowVisibilityPrev, setArrowVisbilityPrev] = useState(false)
	const [arrowVisibilityNext, setArrowVisbilityNext] = useState(true)
	var settings = {
		dots: false,
		infinite: false,
		speed: 100,
		slidesToShow: 3,
		slidesToScroll: 1,
		swipeToSlide: true,
		initialSlide: 0,
		autoplay: true,
		autoplaySpeed: 4000,
		nextArrow: <CustomNextArrow />,
		prevArrow: <CustomPrevArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
					infinite: false,
					dots: false,
				},
			},
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
					dots: false,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					dots: true,
					arrows: true,
					speed: 300,
					infinite: false,
					slidesToScroll: 1,
				},
			},
		],
		afterChange: current => {
			switch (current) {
				case 0:
					setArrowVisbilityPrev(false)
					setArrowVisbilityNext(true)
					break
				case 2:
					setArrowVisbilityNext(false)
					// code block
					break
				default:
					setArrowVisbilityPrev(true)
					setArrowVisbilityNext(true)
			}
		},
	}
	function CustomNextArrow(props) {
		const { className, style, onClick } = props
		return (
			<div
				className={className + (arrowVisibilityNext ? " flex" : " hidden")}
				style={{
					alignItems: "center",
					justifyItems: "center",
					width: "40px",
					height: "40px",
					position: "absolute",
					right: "20px",
					backgroundImage: "none",
					transform: "scaleX(1)",
				}}
				onClick={onClick}
			>
				<svg width="41" height="29" viewBox="0 0 41 29" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M26.9544 20.0012C24.8047 21.7162 22.8046 23.1897 21.1655 24.2694L21.1655 24.2693L21.158 24.2745C20.9418 24.4254 20.7442 24.559 20.5605 24.6832C20.507 24.7194 20.4546 24.7548 20.4033 24.7896L20.3676 24.8136C19.8223 25.1806 19.3576 25.4932 19.069 25.8223C18.9143 25.9988 18.7951 26.1953 18.7403 26.425C18.6852 26.656 18.7019 26.8926 18.7748 27.1385L18.7748 27.1385C18.9545 27.745 19.5848 28.1092 20.3862 28.2386C21.2063 28.371 22.3065 28.2819 23.63 27.8912L23.8713 27.82V27.8138C25.0415 27.4255 26.5986 26.626 28.3135 25.5448L28.3212 25.54L28.3287 25.5346L32.7783 22.3779C32.7786 22.3777 32.7789 22.3775 32.7792 22.3773C33.201 22.082 33.6481 21.7619 34.0755 21.3654C36.7182 19.2922 38.3202 17.8454 39.2738 16.8141C40.1923 15.8208 40.5541 15.1673 40.6166 14.6718L40.6182 14.6667C40.7619 14.1789 40.5867 13.5538 39.7174 12.516C38.8368 11.4647 37.17 9.90251 34.1101 7.50224C33.6826 7.10574 33.2356 6.78566 32.8138 6.49038C32.8135 6.49018 32.8132 6.48998 32.8129 6.48978L28.3633 3.33305L28.3559 3.32778L28.3482 3.32292C26.5141 2.16556 24.8578 1.33111 23.6648 0.978109L23.6648 0.978101C22.3413 0.586628 21.241 0.497032 20.4208 0.629499C19.6191 0.758973 18.989 1.12369 18.8093 1.73092L18.8092 1.73121C18.7368 1.97682 18.7206 2.21327 18.7759 2.44404C18.8309 2.67339 18.9501 2.86978 19.1047 3.04625C19.3938 3.37614 19.8591 3.68963 20.4052 4.05761L20.4379 4.0797C20.4381 4.07982 20.4383 4.07993 20.4385 4.08004C20.4896 4.11471 20.5417 4.14998 20.5951 4.18605C20.7788 4.31021 20.9764 4.44384 21.1926 4.59478L21.1925 4.59489L21.2002 4.59991C22.839 5.67946 24.8375 7.15448 26.989 8.86809L26.9915 8.87014L27.0051 8.88138L27.0584 8.92536L27.2607 9.09265C27.4349 9.2369 27.6833 9.44317 27.9803 9.69116C28.3811 10.0258 28.8701 10.4362 29.3839 10.8725C28.6911 10.8408 27.9301 10.8156 27.0925 10.7988C26.5169 10.7401 25.972 10.7514 25.4582 10.7699L8.97492 10.2526L8.95587 10.252L8.93687 10.2536C8.16526 10.3168 7.44628 10.3325 6.77724 10.3471C6.52322 10.3526 6.27641 10.358 6.03664 10.3657C5.1841 10.3933 4.4041 10.451 3.78481 10.6828C2.50927 11.1589 1.74037 11.6334 1.33997 12.142C1.13356 12.4041 1.02394 12.6768 0.997166 12.9567C0.970787 13.2323 1.02695 13.4919 1.11523 13.7278C1.14973 13.8203 1.17928 13.9083 1.20857 13.9958L1.21162 14.0049C1.23926 14.0875 1.26775 14.1727 1.29823 14.2528C1.36111 14.418 1.44453 14.5962 1.59108 14.7454C1.89753 15.0574 2.36771 15.1363 3.0719 15.0996L3.07356 15.0996C3.34546 15.0854 3.64466 15.0698 3.98409 15.0574L3.98409 15.0575L3.99264 15.057C4.46085 15.0278 5.65264 15.0752 7.25056 15.1683C8.83745 15.2607 10.7983 15.3962 12.7855 15.5382C13.5555 15.5933 14.3299 15.6493 15.0882 15.7041C18.234 15.9317 21.1024 16.1393 22.2228 16.1714L22.229 16.1717L22.2552 16.1729L22.3568 16.1775C22.4455 16.1815 22.5749 16.1875 22.7376 16.1953C23.0631 16.2108 23.5216 16.2334 24.0537 16.2618C25.1173 16.3186 26.4727 16.3981 27.6463 16.4897C28.5608 16.5809 29.4156 16.743 30.193 16.8909C30.3162 16.9149 30.4385 16.9379 30.5591 16.96C29.8106 17.6097 29.0109 18.2863 28.3547 18.8365C27.9487 19.1769 27.598 19.4686 27.3489 19.6751C27.2243 19.7784 27.1251 19.8603 27.0571 19.9165L26.9792 19.9807L26.9592 19.9972L26.9544 20.0012Z"
						fill="#BD1952"
						stroke="#BD1952"
						strokeWidth="0.673226"
					/>
				</svg>
			</div>
		)
	}

	function CustomPrevArrow(props) {
		const { className, style, onClick } = props
		return (
			<div
				className={className + (arrowVisibilityPrev ? " flex" : " hidden")}
				style={{
					alignItems: "center",
					justifyItems: "end",
					width: "40px",
					height: "40px",
					position: "absolute",
					left: "20px",
					backgroundImage: "none",
					transform: "",
				}}
				onClick={onClick}
			>
				<svg width="41" height="29" viewBox="0 0 41 29" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M13.0126 3.41451L13.0049 3.4194L12.9974 3.42471L8.54779 6.58144C8.54749 6.58165 8.54719 6.58186 8.5469 6.58206C8.12509 6.87734 7.67805 7.19741 7.25062 7.59391C4.60785 9.66714 3.00593 11.1139 2.05229 12.1453C1.13382 13.1385 0.772006 13.7921 0.709462 14.2875L0.707942 14.2927C0.56418 14.7805 0.739427 15.4056 1.60868 16.4434C2.48931 17.4947 4.15612 19.0568 7.21601 21.4571C7.64343 21.8536 8.09047 22.1737 8.51228 22.4689C8.51258 22.4692 8.51287 22.4694 8.51317 22.4696L12.9628 25.6263L12.9702 25.6316L12.9779 25.6364C14.812 26.7938 16.4683 27.6282 17.6613 27.9812L17.6613 27.9812C18.9848 28.3727 20.0851 28.4623 20.9053 28.3299C21.707 28.2004 22.3371 27.8357 22.5168 27.2284L22.5168 27.2281C22.5893 26.9825 22.6055 26.7461 22.5502 26.5153C22.4952 26.286 22.376 26.0896 22.2213 25.9131C21.9323 25.5832 21.467 25.2697 20.9209 24.9017L20.8881 24.8796C20.8881 24.8796 20.888 24.8796 20.8879 24.8795C20.8367 24.8448 20.7845 24.8094 20.731 24.7733C20.5473 24.6491 20.3496 24.5155 20.1335 24.3646L20.1336 24.3645L20.1259 24.3594C18.4871 23.2799 16.4886 21.8049 14.3371 20.0912L14.3346 20.0892L14.321 20.078L14.2677 20.034L14.0654 19.8667C13.8912 19.7225 13.6427 19.5162 13.3458 19.2682C12.945 18.9335 12.456 18.5231 11.9421 18.0869C12.635 18.1185 13.396 18.1437 14.2336 18.1605C14.8092 18.2193 15.3541 18.208 15.8679 18.1894L32.3512 18.7067L32.3702 18.7073L32.3892 18.7058C33.1608 18.6425 33.8798 18.6269 34.5489 18.6123C34.8029 18.6068 35.0497 18.6014 35.2895 18.5936C36.1422 18.566 36.9223 18.5083 37.5416 18.2764C38.817 17.8004 39.5858 17.3259 39.9861 16.8174C40.1925 16.5552 40.3022 16.2826 40.3289 16.0027C40.3553 15.727 40.2991 15.4674 40.2109 15.2315C40.1764 15.1391 40.1468 15.0511 40.1175 14.9635L40.1145 14.9544C40.0868 14.8718 40.0583 14.7866 40.0279 14.7065C39.965 14.5413 39.8816 14.3631 39.735 14.2139C39.4286 13.9019 38.9584 13.8231 38.2542 13.8597L38.2521 13.8598C37.9803 13.874 37.6813 13.8895 37.342 13.902L37.342 13.9019L37.3335 13.9024C36.8652 13.9315 35.6735 13.8841 34.0755 13.7911C32.4886 13.6987 30.5278 13.5631 28.5406 13.4211C27.7706 13.3661 26.9962 13.3101 26.2379 13.2552C23.0921 13.0276 20.2237 12.8201 19.1033 12.7879L19.0971 12.7877L19.0709 12.7865L18.9693 12.7819C18.8806 12.7778 18.7512 12.7718 18.5885 12.7641C18.263 12.7485 17.8045 12.7259 17.2724 12.6975C16.2088 12.6408 14.8534 12.5612 13.6799 12.4696C12.7653 12.3784 11.9105 12.2163 11.1331 12.0684C11.0099 12.0445 10.8876 12.0215 10.767 11.9994C11.5155 11.3496 12.3152 10.673 12.9714 10.1228C13.3774 9.78246 13.7281 9.4908 13.9772 9.28425C14.1018 9.18098 14.201 9.099 14.269 9.04287L14.3469 8.97862L14.3669 8.96211L14.3717 8.95819C16.5214 7.24319 18.5215 5.76966 20.1606 4.68999L20.1606 4.69009L20.1681 4.68486C20.3843 4.5339 20.582 4.40026 20.7657 4.27609C20.8189 4.24008 20.871 4.20487 20.9221 4.17026C20.9223 4.1701 20.9225 4.16994 20.9228 4.16978L20.9585 4.14572C21.5039 3.77876 21.9685 3.46614 22.2571 3.13701C22.4118 2.96053 22.531 2.76402 22.5858 2.53438C22.6409 2.30337 22.6242 2.06671 22.5513 1.82088L22.5513 1.82084C22.3715 1.21436 21.7413 0.850189 20.9399 0.720761C20.1198 0.588309 19.0195 0.677462 17.6961 1.06813L17.4548 1.13936L17.4548 1.14555C16.2846 1.53385 14.7275 2.33332 13.0126 3.41451Z"
						fill="#BD1952"
						stroke="#BD1952"
						strokeWidth="0.673226"
					/>
				</svg>
			</div>
		)
	}

	return (
		<>
			<div className={"js-sogehts  relative  mx-auto w-full bg-gradient-to-r from-[#F8DE4B]  to-[#EFBB27] md:mt-24 xl:mt-0"}>
				<div className="mx-auto max-w-[1400px] lg:-mt-[6rem] lg:pt-48">
					<h2 className="h2 mb-12 pt-32 text-center font-FuturaBold text-[24px] uppercase text-black">So geht's</h2>
					<Slider {...settings}>
						<div className="grid self-center">
							<img
								src={process.env.PUBLIC_URL + "/images/danone/sogehts-first.png"}
								className="z-2 relative mx-auto grid max-w-[60%] self-center justify-self-center lg:max-w-[60%]"
							/>
							<div className="self-center text-center text-[22px] text-black"> </div>
						</div>
						<div>
							<img src={process.env.PUBLIC_URL + "/images/danone/sogehts-second.png"} className="z-2 relative mx-auto max-w-[60%]  lg:max-w-[60%]" />
							<div className="self-center text-center text-[22px] text-black"></div>
						</div>
						<div>
							<img src={process.env.PUBLIC_URL + "/images/danone/sogehts-third.png"} className="z-2 relative mx-auto max-w-[60%] lg:max-w-[60%]" />
							<div className="self-center text-center text-[22px] text-black"></div>
						</div>
					</Slider>
					{type === "start" && (
						<div className="mt-12 lg:mt-24">
							<h2 className=" mb-12 text-center font-FuturaBold text-[28px] uppercase text-black lg:text-[36px]">Noch mögliche Erstattungen</h2>
							<RefundCounter />
						</div>
					)}
					<p className=" relative z-[400] mx-auto mt-12 max-w-[100%] px-4 text-center font-FuturaBook font-[500] leading-5 text-black  lg:z-0 lg:mt-24 lg:max-w-[45%] lg:px-0 lg:leading-[30px]">
						* Nur für kurze Zeit. Eine Teilnahme pro Haushalt und IBAN. Die Aktion startet am 01.07.2024 und endet mit 50.000 erstatteten Bons oder spätestens am 30.09.2024.
					</p>
					<p className=" relative z-[400] mx-auto mt-12 max-w-[100%] px-4 text-center font-FuturaBook font-[500] leading-5 text-black  lg:z-0 lg:mt-4 lg:max-w-[45%] lg:px-0 lg:leading-[30px]">
						Teilnahme ab 18 Jahren. Der originale Rechnungsbeleg ist aufzubewahren. Weitere Informationen in den{" "}
						<Link to="teilnahmebedingungen" className="text-red underline" target="_blank">
							Teilnahmebedingungen.
						</Link>
					</p>
					<p className=" relative z-[400] mx-auto mt-2 max-w-[100%] px-4 pb-24  text-center font-FuturaBook font-[500] leading-5 text-black  lg:z-0  lg:max-w-[45%] lg:px-0 lg:leading-[30px]">
						Bei Fragen kontaktiere gerne unseren Aktionssupport:{" "}
						<a href="mailto:info@yopro-gratis-testen.de" className="text-red underline" target="_blank">
							info@yopro-gratis-testen.de{" "}
						</a>
					</p>
				</div>
			</div>
		</>
	)
}

export default Sogehts
